export function openLink(url: string): void {
  window.open(url, '_blank');
}
